import './mycontent.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';

import MyContent from '../../components/MyContent';
import MyContentSeries from '../../components/MyContent/Series';
import Device from '../../devices/device';
import SimpleGetRequestTask from '../../requests/tasks/SimpleGetRequestTask';
import RequestManager from '../../requests/RequestManager';
import Translator from '../../requests/apa/Translator';
import DeleteFavorite from '../../requests/tasks/user/DeleteFavoriteTask';
import { deleteFavorited, deleteFavoritedChannels } from '../../reducers/user';
import { showModal, MODAL_ACCIONES_CONTENIDO, HIDE_MODAL } from '../../actions/modal';
import { setMetricsEvent } from '../../actions/metrics';
import { setResumeData } from '../../actions/resume';
import { showNotification } from '../../actions/notification';
import { playFullMedia } from '../../actions/playmedia';
import store from '../../store';
import RibbonsUtil from '../../utils/RibbonsUtil';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from '../../utils/Utils';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import { NPVR_RECORDABLE_EVENT_STATUS } from '../../AAF/Npvr/Constans';

class MyContentContainer extends Component {
  state = {
    reload: false,
    ribbonsUser: []
  };
  setResumeDataTimeoutId = null;
  userHash = this.props.user.session_userhash || '';

  handleRecordingPlay = async (groupId = '', title = '', actions = {}, data = null) => {
    console.log('dan: actions', actions);
    console.log('dataCard', data);
    if (actions.play && actions.play !== '') {
      const pgmUrl = actions.play.smooth_streaming;
      //const pgmUrl ='http://microfwk-tv2sony-test.clarovideo.net/services/player/getmedia?device_category=tv&device_manufacturer=sony&device_model=sony&device_type=tv&device_id=049dd27b-1113-f886-b235-86e44906ba33&api_version=v5.8&region=mexico&authpn=amco&authpt=12e4i8l6a581a&HKS=l8elk9sdnvi6f550a9shfrsua2&user_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MTY5MjkxNjIsImV4cCI6MTUyMjExMzE2MiwidXNyIjp7InVzZXJfaWQiOiIyMTc5MjM5MyIsInVzZXJuYW1lIjoianNhbmNoZXpfZXh0QGFtY28ubXgiLCJlbWFpbCI6ImpzYW5jaGV6X2V4dEBhbWNvLm14IiwiZmlyc3RuYW1lIjoiYWFhYXRlc3QiLCJsYXN0bmFtZSI6ImFhYWFhdGVzdCIsImNvdW50cnlfY29kZSI6Ik1YIiwicmVnaW9uIjoibWV4aWNvIiwiYWNjZXB0ZWRfdGVybXMiOjF9fQ.e8aphpdK-3uyW_KEYIAi6h9Mqplfbvgnd4HNWu2ssBo&stream_type=smooth_streaming&record_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ2aWRlb191cmwiOiJcL3ZpZGVvXC9zM1wvdGVzdF9jbGFyb3ZpZGVvXzU0MTAwMjQ5NjY4MTYwMDAwLmlzbVwvTWFuaWZlc3QiLCJncm91cF9pZCI6NzQxNjg0LCJsaXZlcmVmIjoiZm94MWhkc3ViIiwiZHVyYXRpb24iOjMzMDAsInJlc291cmNlSWQiOiJjYXB0dXJldGVzdCIsInByb3ZpZGVySWQiOiJoYXJtb25pY3MiLCJyZWNvcmRlcklkIjoiY2FwdHVyZSJ9.nEY7GPYYCGKOCud9mfuZjf5ZfQ9fkAznGeRgibF5Tvw%3F' ;
      this.props.playFullMedia({
        playerstate: 'PLAYING',
        source: {
          //videoid: 764423
          videosource: pgmUrl
        },
        size: {
          top: 0,
          left: 0,
          width: 1280,
          height: 720
        },
        ispreview: false,
        islive: false,
        ispip: false,
        videosourceoptions: actions.play,
        event: null,
        npvrEvent: data
      });
      /*
       const playerGetMediaTask = new SimpleGetRequestTask(pgmUrl, null, true, true); //como se implementaba antes del refactor
       const result = await RequestManager.addRequest(playerGetMediaTask);
       console.log('dan:', result);

       // &&&&&&&&&&&&&&
       let playerStreamingUtils = new PlayerStreamingUtils();
       let PGM = playerStreamingUtils.replaceSourceMedia(result.response, 'smooth_streaming', 'FOX');
       // &&&&&&&&&&&&&&
       this.props.history.push(`/player/${groupId}`, {
       //pgm: result.response,
       pgm: PGM,
       title,
       isRecord: true,
       streamType: 'smooth_streaming',
       });
       */
    }
  };

  handleRecordingDelete = async (actions, cardData = null) => {
    console.log('dan: actions', actions);
    if (actions.delete && actions.delete !== '') {
      const notificationProps = {
        show: true,
        title: Translator.get('my_recordings_title', 'Mis Grabaciones'),
        msg: Translator.get(
          'recording_notification_deleted',
          'El contenido se ha eliminado de mis grabación correctamente.'
        ),
        apaAsset: 'player_controls_recording_icon',
        type: 'notification'
      };
      if (NpvrUtil.recordingIconEnable().enable) {
        const groupId = cardData.group_id;
        const eventId = cardData.event_id;
        const eventAlfId = cardData.event_alf_id
        if(NpvrUploader.isEventSerie(cardData)){
          await NpvrUploader.updateStatusFromListSerie(cardData.ext_series_id,cardData.group_id, NPVR_RECORDABLE_EVENT_STATUS, true);
          NpvrUploader.deleteByUrl(actions.delete, groupId).then(() => {
            this.getData();
          });
        }
        else{
          NpvrUploader.deleteByUrl(actions.delete, groupId, eventId, eventAlfId).then(() => {
            this.getData();
          });
        }
      } else {
        const deleteRecordingTask = new SimpleGetRequestTask(actions.delete, null);
        const result = await RequestManager.addRequest(deleteRecordingTask);
        this.getData();
        if (!result.response.success) {
          notificationProps.msg = Translator.get(
            'recording_notification_deleted_error',
            'El contenido no pudo ser eliminado intentalo nuevamente.'
          );
        } else {
          const saved = DeviceStorage.getItem('recordings');
          const parsed = Utils.isJson(saved) ? JSON.parse(saved) : {};
          if (
            cardData &&
            cardData.eventid_programme_id &&
            parsed[cardData.eventid_programme_id]
          ) {
            delete parsed[cardData.eventid_programme_id];
            DeviceStorage.setItem('recordings', JSON.stringify(parsed));
          }
        }
      }
      this.props.showNotification(notificationProps);
    }
  };

  handleFavoriteDelete = async (groupId, type) => {
    const service = new DeleteFavorite(groupId);
    const cb = () => {};

    RequestManager.addRequest(service)
      .then(resp => {
        const responseData = resp.data;
        if (responseData && responseData.delete) {
          //Borrarlo en redux de canales o VOD segun corresponda
          if (type === 'vod') {
            console.log('>> Se borra de VOD');
            this.props.deleteFavorited(groupId);
          } else {
            console.log('>> Se borra de CANALES');
            this.props.deleteFavoritedChannels(groupId);
          }
        }

        if (typeof cb === 'function') return cb(this);
      })
      .catch(err => {
        console.error(err);
      });
  };

  hideModal = () => {
    store.dispatch({
      type: HIDE_MODAL,
      modalType: MODAL_ACCIONES_CONTENIDO
    });
  };

  getMetadataTextByContentType(content){
    if(content.isSeries){
      return {
        metadataTitle:  Translator.get('npvr_recording_modal_toDelete_serie_title','Eliminar temporada'),
        metadataContent: Translator.get('npvr_recording_modal_toDelete_serie_description','¿Estás seguro que quieres eliminar todas las grabaciones de esta temporada?'),
        metadataDeleteButton: Translator.get('npvr_recording_modal_toDelete_deleteRecord_button','Eliminar')
      }
    }
    if(content.isEpisode){
      if(content.status === 'ingested'){
        return {
          metadataTitle:  Translator.get('npvr_recording_modal_toDelete_Episode_title','Eliminar episodio'),
          metadataContent: Translator.get('npvr_recording_modal_toDelete_pisode_description','¿Estás seguro que quieres eliminar la grabación del episodio?'),
          metadataDeleteButton: Translator.get('npvr_recording_modal_toDelete_deleteRecord_button','Eliminar')
        }
      }
      else{
        return {
          metadataTitle:  Translator.get('npvr_recording_modal_toCancel_episode_title','Cancelar grabación'),
          metadataContent: Translator.get('npvr_recording_modal_toCancel_episode_description','¿Estás seguro que quieres cancelar la grabación del episodio'),
          metadataDeleteButton: Translator.get('npvr_recording_modal_toDelete_cancel_button','Cancelar')
        }
      }
    }
    if(content.status === 'ingested'){
      return {
        metadataTitle:  Translator.get('delete_recording_modal_title','Eliminar grabación'),
        metadataContent: Translator.get('delete_recording_modal_content','¿Estás seguro que deseas eliminar esta grabación?'),
        metadataDeleteButton: Translator.get('npvr_recording_modal_toDelete_deleteRecord_button','Eliminar')
      }
    }
    else{
      return {
        metadataTitle:  Translator.get('npvr_recording_modal_toCancel_cancelRecord_button','Cancelar grabación'),
        metadataContent: Translator.get('delete_schedule_modal_content','¿Estás seguro que deseas cancelar esta grabación?'),
        metadataDeleteButton: Translator.get('npvr_recording_modal_toDelete_cancel_button','Cancelar')
      }
    }
    
  }

  yellowAction(cardData) {
    const modal = document.getElementsByClassName('modal-overlay');

    const node = cardData.node;
    const title = cardData.title;
    const groupId = cardData.group_id;
    const actions = cardData.actions;

    if (modal.length === 0) {
      const playButtonVisible = actions.play && actions.play !== '';
      const playContent = playButtonVisible
        ? () => {
          this.hideModal();
          this.handleRecordingPlay(groupId, title, actions, cardData);
        }
        : null;
      const myContentDeleteHandler =
        node === 'myRecords'
          ? () => this.handleRecordingDelete(actions, cardData)
          : () => this.handleFavoriteDelete(groupId);
      const { metadataTitle, metadataContent, metadataDeleteButton } = this.getMetadataTextByContentType(cardData);
      this.props.showModal({
        modalType: MODAL_ACCIONES_CONTENIDO,
        modalProps: {
          playContent,
          playButtonVisible,
          myContentDeleteHandler,
          title: metadataTitle,
          content: metadataContent,
          deleteButtonText: metadataDeleteButton
        }
      });
    }
  }

  handleKeyPress = (e, cardData) => {
    if (e && e.keyCode) {
      const keys = Device.getDevice().getKeys();
      const key = keys.getPressKey(e.keyCode);

      switch (key) {
        case 'YELLOW':
          e.preventDefault();
          e.stopPropagation();

          this.yellowAction(cardData);

          break;
      }
    }
  };

  setResumeData = cardData => {
    if (!cardData.group_id) {
      return;
    }

    if (this.setResumeDataTimeoutId) {
      clearTimeout(this.setResumeDataTimeoutId);
    }

    cardData.previewImage = cardData.image_still;

    this.setResumeDataTimeoutId = setTimeout(
      () => {
        this.props.setResumeData({
          ...cardData,
          overWrite: true
        });
      },
      this.props.user.isLoggedIn ? 300 : 1000
    );
  };

  playFullMedia = group_id => {
    this.props.playFullMedia({
      playerstate: 'PLAYING',
      source: {
        //videoid: 764423
        videoid: group_id
      },
      size: {
        top: 0,
        left: 0,
        width: 1280,
        height: 720
      },
      ispreview: false,
      islive: true,
      ispip: false,
      event: null
    });
  };

  request(node, userStatus) {
    let rb = new RibbonsUtil();
    rb.getMiddlewareRibbons(node, userStatus, resp => {
      //const infiniteList = resp.gridType !== 'ribbons';
      //const ribbons = resp.components;
      if (resp.byUser && this.userHash) {
        rb.getUserMiddlewareRibbons(
          node,
          userStatus,
          resp => {
            let ribbonsUser = resp.components;
            ribbonsUser = ribbonsUser.filter(it => it.url);
            this.setState({ ribbonsUser });
          },
          this.props.user && this.props.user.user_token
            ? this.props.user.user_token
            : null
        );
      }
      console.info('[MyContent] getMiddlewareRibbons after request');
    });
  }

  componentWillMount() {
    this.getData();
  }

  resolveUserLogin() {
    let userType = 'anonymous';
    if (this.props.user.isLoggedIn && this.props.user.superhighlight) {
      userType = this.props.user.superhighlight.join();
    }
    return userType;
  }

  getData() {
    const node = this.props.code || 'misgrabaciones';
    const userStatus = this.resolveUserLogin();
    this.request(node, userStatus);
  }

  render() {
    return (
      <div>
        <Route
          exact
          path={'/node/misgrabaciones'}
          render={() => (
            <MyContent
              user={this.props.user}
              setResumeData={this.props.setResumeData}
              setMetricsEvent={this.props.setMetricsEvent}
              handleKeyPress={this.handleKeyPress}
              handleRecordingPlay={this.handleRecordingPlay}
              reload={this.state.reload}
              ribbonsUser={this.state.ribbonsUser}
            />
          )}
        />
        <Route
          exact
          path={'/node/misgrabaciones/series'}
          render={({ location }) => {
            const { state: locationState } = location;
            const { timeUsed, actions } = locationState;
            return (
              <MyContentSeries
                timeUsed={timeUsed}
                actions={actions}
                user={this.props.user}
                setResumeData={this.props.setResumeData}
                setMetricsEvent={this.props.setMetricsEvent}
                handleKeyPress={this.handleKeyPress}
                handleRecordingPlay={this.handleRecordingPlay}
                reload={this.state.reload}
              />
            );
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });
const ConnectedMyContent = connect(
  mapStateToProps,
  {
    showModal,
    setResumeData,
    setMetricsEvent,
    showNotification,
    playFullMedia,
    deleteFavorited,
    deleteFavoritedChannels
  }
)(MyContentContainer);
export default withRouter(ConnectedMyContent);



// WEBPACK FOOTER //
// ./src/containers/MyContent/index.jsx